(function(){
  var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var yr = document.getElementById('yr'); if(yr) yr.textContent = new Date().getFullYear();

  // hero enter
  var hero = document.getElementById('hero');
  if(hero){ requestAnimationFrame(function(){ setTimeout(function(){ hero.classList.add('in'); }, 60); }); }

  // mobile nav
  var burger = document.getElementById('burger'), links = document.getElementById('navlinks');
  if(burger && links){
    burger.addEventListener('click', function(){
      var open = links.classList.toggle('open');
      burger.setAttribute('aria-expanded', open ? 'true':'false');
    });
    links.addEventListener('click', function(e){ if(e.target.tagName==='A'){ links.classList.remove('open'); burger.setAttribute('aria-expanded','false'); }});
  }

  // reveal on scroll
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
    }, {threshold:.14, rootMargin:'0px 0px -8% 0px'});
    document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
  }

  // marquee tiles
  var mq = document.getElementById('marquee');
  if(mq){
    var tiles = [
      {c:'blue',  t:'Bold ideas',       s:'01 // CONNECT'},
      {c:'paper', t:'Late nights',      s:'02 // CREATE'},
      {c:'flame', t:'Unexpected work',  s:'03 // PUSH'},
      {c:'dark',  t:'Cultural moments', s:'04 // EXPERIENCE'},
      {c:'blue',  t:'The community',    s:'05 // REMEMBER'},
      {c:'dark',  t:'Film & fashion',   s:'JOLLY'},
      {c:'flame', t:'Music & art',      s:'JOLLY'},
      {c:'paper', t:'Events people talk about', s:'JOLLY'}
    ];
    var rots = [-3,2,-2,3,-1,2,-3,1], html='';
    for(var pass=0; pass<2; pass++){
      tiles.forEach(function(tl,i){
        html += '<div class="tile '+tl.c+'" style="--r:'+rots[i%rots.length]+'deg" '+(pass?'aria-hidden="true"':'')+'>'+
                '<span class="grain"></span><span class="t-ico">'+tl.s+'</span><h4>'+tl.t+'</h4></div>';
      });
    }
    mq.innerHTML = html;
    if(rm){ mq.style.animation='none'; }
  }

  // generative art fallback (only where a canvas exists — placeholder products)
  function draw(cv){
    var seed = parseInt(cv.getAttribute('data-seed'),10)||1;
    function rnd(){ seed = (seed*9301+49297)%233280; return seed/233280; }
    var ctx = cv.getContext('2d'), W=cv.width, H=cv.height;
    var palettes = [
      ['#0E0F14','#2B47FF','#FF6A2B','#ECEAE4'],
      ['#0E0F14','#FF6A2B','#7E8BFF','#ECEAE4'],
      ['#15161E','#2B47FF','#ECEAE4','#FF6A2B'],
      ['#0B0C11','#FF6A2B','#2B47FF','#ECEAE4']
    ];
    var p = palettes[seed % palettes.length];
    ctx.fillStyle = p[0]; ctx.fillRect(0,0,W,H);
    for(var g=0; g<3; g++){
      var gx=rnd()*W, gy=rnd()*H, gr=(rnd()*.5+.4)*W;
      var rad=ctx.createRadialGradient(gx,gy,0,gx,gy,gr);
      rad.addColorStop(0, p[1+g%3]); rad.addColorStop(1,'rgba(0,0,0,0)');
      ctx.globalAlpha=.5; ctx.fillStyle=rad; ctx.beginPath(); ctx.arc(gx,gy,gr,0,7); ctx.fill();
    }
    ctx.globalAlpha=1; ctx.lineCap='round';
    for(var i=0;i<7;i++){
      ctx.strokeStyle = p[1+(i%3)]; ctx.lineWidth = 4 + rnd()*26; ctx.globalAlpha = .5 + rnd()*.5;
      ctx.beginPath(); ctx.moveTo(rnd()*W, rnd()*H); ctx.lineTo(rnd()*W, rnd()*H); ctx.stroke();
    }
    ctx.globalAlpha=.9; ctx.fillStyle=p[2];
    ctx.beginPath(); ctx.arc(rnd()*W, rnd()*H, 20+rnd()*70, 0, 7); ctx.fill();
    ctx.globalAlpha=1;
  }
  document.querySelectorAll('.art canvas').forEach(draw);
})();
